export default __webpack_public_path__ + "static/media/warning--koala-crossing--g4.f4a67cc8.png";